export const animationStates = {
	initial: "initial",
	animate: "animate",
	exit: "exit",
};

export const fade = {
	variants: {
		initial: {
			opacity: 0,
		},
		animate: {
			opacity: 1,
		},
		exit: {
			opacity: 0,
		},
	},
};

export const slideHeight = {
	variants: {
		initial: {
			height: 0,
		},
		animate: {
			height: "100%",
		},
		exit: {
			height: 0,
		},
	},
};

export const slideWidth = {
	variants: {
		initial: {
			width: 0,
		},
		animate: {
			width: "100%",
		},
		exit: {
			width: 0,
		},
	},
};

export const blur = {
	variants: {
		initial: {
			opacity: 0,
			filter: "blur(20px)",
		},
		animate: {
			opacity: 1,
			filter: "blur(0px)",
			transition: {
				duration: 0.6,
			},
		},
		exit: {
			opacity: 0,
			filter: "blur(20px)",
		},
	},
};

export const gridContainer = {
	variants: {
		initial: {
			opacity: 0,
		},
		animate: {
			opacity: 1,
			transition: {
				duration: 0.2,
				staggerChildren: 0.15,
			},
		},
		exit: {
			opacity: 0,
		},
	},
};

export const gridItem = {
	variants: {
		initial: {
			opacity: 0,
			y: 20,
		},
		animate: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 0.25,
				y: {
					duration: 0.5,
					ease: "easeOut",
				},
			},
		},
		exit: {
			opacity: 0,
		},
	},
};
